import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  paperWeekly: {
    zIndex: 1,
    position: 'sticky',
    top: 65,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    display: 'grid',
    gridTemplateColumns: '6.1fr repeat(14,1.1fr)',
    height: 60,
    marginBottom: 20,
    backgroundColor: theme.palette.background.default,
    boxShadow:
      '0px 1px 1px -1px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 8%)',
    [theme.breakpoints.down('sm')]: {
      width: '1440px'
    }
  },
  mainBigDate: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  prevPageIcon: {
    transform: `rotate(${lang === 'fa' ? '0deg' : '180deg'})`
  },
  arrowIcon: {
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  arrowIconLeft: {
    transform: `rotate(${lang === 'fa' ? '0deg' : '180deg'})`
  },
  bigDateContainer: {
    position: 'relative'
  },
  bigDate: {
    width: 170,
    textAlign: 'center'
  },
  datePickerContainer: {
    position: 'absolute',
    top: 32,
    zIndex: 1
  },
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 14,
    color: 'gray',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  dayContainerSmallFa: {
    fontSize: 9
  },
  dayContainerSmallEn: {
    fontSize: 12
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  }
}))
export default useStyles
